/**
 * Tymes4 Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type RegistrationTypeEnum = 'NotSpecified' | 'Person' | 'Company' | 'Both';

export const RegistrationTypeEnum = {
    NotSpecified: 'NotSpecified' as RegistrationTypeEnum,
    Person: 'Person' as RegistrationTypeEnum,
    Company: 'Company' as RegistrationTypeEnum,
    Both: 'Both' as RegistrationTypeEnum
};

